export const CHANGE_SELECTED_ROWS = "CHANGE_SELECTED_ROWS";

interface ChangeSelectionAction {
  type: typeof CHANGE_SELECTED_ROWS;
  payload: any;
}

export type ChangeSelectionTypes = ChangeSelectionAction;
